import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {EventModelUploadDataService} from "../event-model-upload-data.service";
import {Subject} from "rxjs";
import {COMMON_FORM_IMPORTS} from "../../../../shared/import-groups/Common";
import {NameAndDescriptionPipe} from "../../../../shared/pipes";
import {CommonModule} from "@angular/common";
import {NgxSkeletonLoaderModule} from "ngx-skeleton-loader";

@Component({
    selector: 'event-model-upload-select-component',
    templateUrl: './event-model-upload-select-component-type.component.html',
    imports: [
        COMMON_FORM_IMPORTS,
        NameAndDescriptionPipe,
        CommonModule,
        NgxSkeletonLoaderModule,
    ],
    styleUrls: ['../extract-event-options.component.less']
})
export class EventModelUploadSelectComponentTypeComponent implements OnInit, OnDestroy {
    private readonly onDestroy = new Subject<void>();

    @Input() componentTypeID: string;
    @Output() componentTypeIDChange = new EventEmitter<string>();

    compareWith: (a: any, b: any) => boolean;

    constructor(public dataService: EventModelUploadDataService) {
        this.compareWith = (a, b) => {
            return a === b;
        };
    }

    ngOnInit(): void {
    }

    ngOnDestroy(): void {
        this.onDestroy.next();
        this.onDestroy.unsubscribe();
    }

    setComponentType(componentTypeID: string) {
        this.componentTypeIDChange.next(componentTypeID);
    }
}
